export const TENCENTV3_CREATIVE = [
  {
    title: '开关',
    key: 'switch',
    width: '82',
    type: 'basic',
    fixed: true
  },
  {
    title: '创意名称',
    key: 'adName',
    width: '280',
    type: 'basic',
    fixed: true
  },
  {
    title: '状态',
    key: 'adStatusStr',
    width: '90',
    type: 'basic',
    fixed: true,
    overflow: true
  },
  {
    title: '操作',
    key: 'control',
    width: '130',
    type: 'basic',
    fixed: true
  },
  {
    title: '流量位置',
    key: 'inventoryType',
    width: '200',
    type: 'basic',
    overflow: true
  },
  {
    title: '计划',
    width: '150',
    key: 'projectName',
    type: 'basic',
    overflow: true
  },
  {
    title: '投放时间',
    width: '100',
    key: 'planTime',
    type: 'basic'
  },
  {
    title: '账面消耗(元)',
    key: 'paperAmount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '实际消耗(元)',
    key: 'amount',
    width: '116',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '展示量',
    key: 'pv',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击数',
    key: 'clickNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '点击率',
    key: 'clickRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均点击单价',
    key: 'perClickPrice',
    width: '118',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '平均千次展示单价',
    key: 'thousandsOfDisplayCosts',
    width: '142',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化数',
    key: 'convertNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化成本',
    key: 'convertCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '转化率',
    key: 'convertRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活数',
    key: 'activeNum',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活成本',
    key: 'activeCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '激活率',
    key: 'activeRate',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册数',
    key: 'register',
    width: '82',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '注册成本',
    key: 'registerCost',
    width: '94',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '付费次数',
    key: 'payCount',
    width: '110',
    sortable: 'custom',
    type: 'report'
  },
  {
    title: '投放ID',
    key: 'adId',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '媒体',
    key: 'mediaName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '账号',
    key: 'adAccountName',
    width: '140',
    type: 'other',
    overflow: true
  },
  {
    title: '投放游戏',
    key: 'gameName',
    width: '110',
    type: 'other',
    overflow: true
  },
  {
    title: '投放人员',
    key: 'launchOpName',
    width: '80',
    type: 'other',
    overflow: true
  },
  {
    title: '创建时间',
    key: 'createTime',
    width: '120',
    type: 'other'
  },
  {
    title: '同步时间',
    key: 'synTime',
    width: '120',
    type: 'other'
  }
]
